<button
  outline
  nbButton
  size="small"
  title="{{ title }}"
  [nbContextMenu]="menu"
  [nbContextMenuTag]="tag">
  {{ title }}&nbsp; <i class="{{ icon }}"></i>
</button>
